import { render, staticRenderFns } from "./ScreenTransvaginalHisterectomia.vue?vue&type=template&id=f9acea10&scoped=true&"
import script from "./ScreenTransvaginalHisterectomia.vue?vue&type=script&lang=js&"
export * from "./ScreenTransvaginalHisterectomia.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTransvaginalHisterectomia.vue?vue&type=style&index=0&id=f9acea10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9acea10",
  null
  
)

export default component.exports